export const PATH_ROUTES = {
  home: "/",
  titulacions: "/titulacions",
  professionsRegulades: "/professions-regulades",
  professionalsSanitaris: "/professionals-sanitaris",
  /** P4 – Desajust laboral per titulació */
  desajustLaboralTitulacio: "/desajust-laboral-titulacio",
  /** P5 – Oferta universitària i ocupació sectorial */
  ofertaUniversitariaOcupacio: "/oferta-universitaria-i-ocupacio-sectorial",
  login: "login",
  documentsViewer: "tasks/:taskId",
  whiteList: "white-list",
} as const;

/** Rutes antigues (pre-renombrat) → redirecció permanent al desplegament */
export const LEGACY_MODULE_PATH_REDIRECTS: Record<string, string> = {
  "/oferta-universitaria": PATH_ROUTES.desajustLaboralTitulacio,
  "/desajust-titulacio": PATH_ROUTES.ofertaUniversitariaOcupacio,
};
